import * as boxSlideShowUtils from './utils/boxSlideShowUtils';

const utils = {
  boxSlideShowUtils,
};

export { utils };
